// extracted by mini-css-extract-plugin
export default {"indicators":"OnlineIndicators_indicators__MEwf0"};